import React, { useMemo } from 'react';
import {
  TaskExportConfigurationContext,
  TaskExportConfigurationContextProps,
  taskExportConfigurationSlice,
} from '../context/TaskExportConfigurationContext';
import { TaskExportConfiguration } from '../types/task_export_configuration/taskExportConfiguration';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

interface TaskExportConfigurationProviderProps {
  children: React.ReactNode;
}

export default function TaskExportConfigurationProvider({ children }: TaskExportConfigurationProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.taskExportConfigurations.items);
  const loading = useAppSelector(state => state.taskExportConfigurations.loading);

  const taskExportConfigurations = useMemo(() => {
    return new Map(items.map(item => [item.id, new TaskExportConfiguration(item)]));
  }, [items]);

  const taskExportConfigurationContext: TaskExportConfigurationContextProps = {
    taskExportConfigurations,
    taskExportConfigurationsLoading: loading,
    setTaskExportConfigurations: (taskExportConfigurations: Map<string, TaskExportConfiguration>) =>
      dispatch(taskExportConfigurationSlice.actions.setAll([...taskExportConfigurations.values()])),
  };

  return (
    <TaskExportConfigurationContext.Provider value={taskExportConfigurationContext}>
      {children}
    </TaskExportConfigurationContext.Provider>
  );
}
